export default __webpack_public_path__ + "static/media/playing.2ee8cf0b.mp3";